module.exports = __webpack_public_path__ + "static/img/32-3.496e2e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/32-3.jpg
// module id = WLGy
// module chunks = 0